// Preliminary Robotics Vision rates. Keep changes here so the planner, quick
// estimate and exported request always use the same assumptions.
export const PROJECT_PRICING = {
  cableReserve: 0.1,
  storageReserve: 0.2,
  support: { upToFour: 2900, upToEight: 3900 },
  installation: {
    indoorCamera: 1500,
    outdoorCamera: 2000,
    cableMetre: 40,
    systemSetup: 3000,
  },
};
// Owner-requested budget revision, 2026-10-11. Standard installation only;
// chasing walls, access equipment and difficult routes are quoted separately.
export const roundMoney = (value: number) => Math.round(value);

export function supportMonthlyPrice(cameraCount: number): number | null {
  if (!Number.isInteger(cameraCount) || cameraCount < 1 || cameraCount > 8) return null;
  return cameraCount <= 4 ? PROJECT_PRICING.support.upToFour : PROJECT_PRICING.support.upToEight;
}
